define('views/root/pano',[
	'backbone',
	'views/_base/baseview',
	'text!views/root/pano.html',
	'text!views/root/pano_rxsavings.html',
	'text!views/root/pano_almyblue.html',
	'text!views/root/pano_alahealth.html',
	'text!views/root/pano_sunset.html',
	'fancybox',
	'views/shared/video_iframe/video_iframe',
], function (
	Backbone,
	BaseView,
	Template,
	RxSavingsTemplate,
	AlMyBlueTemplate,
	AlaHealthTemplate,
	PanoSunset,
	Fancybox,
	VideoIframe
) {
	'use strict';

	return BaseView.extend({
		// id       : '',
		tagName: 'div',
		className: 'pano-inner-container',
		template: _.template(Template),
		isRender: true,
		needsAuth: false,
		events: {
			'click #pano-video-btn': 'showVideo',
			'click .js-call-to-action': 'goToRoute',
		},

		initialize: function (options) {
			options = options || {};

			this.site_version = pf.getContent('version.id');

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this, options);
		},

		render: function () {
			var template = null;

			if (this.site_version == enums.siteVersion.rxsavings) {
				template = _.template(RxSavingsTemplate);
			} else if (this.site_version == enums.siteVersion.alahealth) {
				template = _.template(AlaHealthTemplate);
			} else if (isSunsetting()) {
				template = _.template(PanoSunset);
			} else {
				template = _.template(Template);
			}

			this.$el.addClass(pf.getContent('version.name')).html(template());

			this.addContent();

			return this;
		},

		addContent: function () {
			var that = this,
				content = document.createElement('div'),
				logo_container = document.createElement('div'),
				logo = pf.getContent('global.logo.rewards'),
				header_md = document.createElement('h1'),
				header = document.createElement('h1'),
				text = document.createElement('p'),
				lower_content = document.createElement('div'),
				call_to_action = document.createElement('a'),
				disclaimer = document.createElement('p');

			lower_content.className =
				'lower-content-' + pf.getContent('version.name');

			logo_container.className = 'pano-content-logo';
			logo_container.innerHTML = logo ? logo : '';

			header_md.className = 'pano-header-md';
			header_md.innerHTML = pf.getContent(
				'landing.content.pano.top_header',
				'string'
			);

			header.className = 'pano-header';
			header.innerHTML = pf.getContent('landing.content.pano.header', 'string');

			text.className = 'pano-copy';
			text.innerHTML = pf.getContent('landing.content.pano.copy', 'string');

			content.appendChild(logo_container);
			content.appendChild(header_md);
			content.appendChild(header);
			content.appendChild(text);

			if (this.site_version == enums.siteVersion.bcbsal) {
				var marketing_image = document.createElement('img'),
					marketing_image_mobile = document.createElement('img');

				marketing_image.className = 'pano-content-marketing-image';
				marketing_image.src =
					'img/landing/pano/_versions/' +
					pf.getContent('version.name') +
					'/' +
					pf.getContent('landing.content.pano.marketing_image');

				marketing_image_mobile.className =
					'pano-content-marketing-image-mobile';
				marketing_image_mobile.src =
					'img/landing/pano/_versions/' +
					pf.getContent('version.name') +
					'/' +
					pf.getContent('landing.content.pano.marketing_image_mobile');

				content.appendChild(marketing_image);
				content.appendChild(marketing_image_mobile);
			}

			if (pf.getContent('landing.content.pano.button.show') !== false) {
				call_to_action.href = pf.getContent('landing.content.pano.button.url');
				call_to_action.className =
					'btn btn-default btn-jumbo btn--pill js-call-to-action';
				call_to_action.innerHTML = pf.getContent(
					'landing.content.pano.button.text',
					'string'
				);
				call_to_action.addEventListener('click', function (e) {
					that.goToRoute(e);
				});

				disclaimer.className = 'pano-copy-exclusive';
				disclaimer.innerHTML = pf.getContent(
					'landing.content.pano.disclaimer',
					'string'
				);

				lower_content.appendChild(call_to_action);
				lower_content.appendChild(disclaimer);

				content.appendChild(lower_content);
			}

			this.$el.find('.js-pano-content').html(content);
		},

		showVideo: function () {
			var video_url = pf.getContent('landing.content.pano.video.url');

			this.videoView = new VideoIframe({
				videoID: video_url,
				autoPlay: true,
			});

			$.fancybox(this.videoView.el, {
				closeBtn: true,
				scrolling: 'no',
			});
		},

		goToRoute: function (e) {
			if (pf.fb_pixel) {
				pf.fb_pixel.checkout();
			}

			pf.navigate($(e.target).attr('href'));

			return false;
		},

		close: function () {},
	});
});

